import { useSelector } from "react-redux";

export const useUserPermissions = () => {
  const { isDefault, scrp } = useSelector(
    (state) => state?.global_user_data?.data?.theme[0]
  );

  // Seletores específicos evitam re-renders desnecessários (warning do
  // React-Redux quando o seletor retornava o state inteiro).
  const activeScreenName = useSelector((state) => state?.activeScreenName);

  const { act } = useSelector(
    (state) => state?.global_user_data?.data?.theme[0]
  );

  const canCreate = () => {
    if (isDefault) {
      return act?.includes("W");
    }
    return scrp
      ?.filter((screen) => screen.name === activeScreenName)[0]
      ?.act?.includes("W");
  };

  const canDelete = () => {
    if (isDefault) {
      return act?.includes("D");
    }
    return scrp
      ?.filter((screen) => screen.name === activeScreenName)[0]
      ?.act?.includes("D");
  };

  const canRead = () => {
    if (isDefault) {
      return act?.includes("R");
    }
    return scrp
      ?.filter((screen) => screen.name === activeScreenName)[0]
      ?.act?.includes("R");
  };

  const canUpdate = () => {
    if (isDefault) {
      return act?.includes("E");
    }
    return scrp
      ?.filter((screen) => screen.name === activeScreenName)[0]
      ?.act?.includes("E");
  };

  return {
    canCreate,
    canDelete,
    canRead,
    canUpdate,
  };
};
